import { useEffect } from "react";
import { useNavigate } from "@tanstack/react-router";
import { useAuth } from "../../lib/auth-context";
import { LoadingSpinner } from "./LoadingSpinner";

type GuestGuardProps = {
	children: React.ReactNode;
};

// Guest guard component - redirects to dashboard if already logged in
export function GuestGuard({ children }: GuestGuardProps) {
	const { isAuthenticated, isLoading, isAdmin, hasProAccess } = useAuth();
	const navigate = useNavigate();

	useEffect(() => {
		if (!isLoading && isAuthenticated) {
			// Redirect admin-only users (no pro access) to admin panel
			// Users with pro access go to pro dashboard
			const shouldGoToAdmin = isAdmin && !hasProAccess;
			navigate({ to: shouldGoToAdmin ? "/admin" : "/" });
		}
	}, [isLoading, isAuthenticated, isAdmin, hasProAccess, navigate]);

	if (isLoading) {
		return <LoadingSpinner />;
	}

	if (isAuthenticated) {
		return <LoadingSpinner />; // Show spinner while redirecting
	}

	return <>{children}</>;
}
